export class WorkspaceScimToken {
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.tokenPreview = model.tokenPreview;
        this.workspaceId = model.workspaceId;
        this.createdBy = model.createdBy;
        this.createdAt = new Date(model.createdAt);
    }
}
